const reportDB = require('../../../../../components/report/report-db')
const report = require('../../../../../components/report/report')
const style = require('../../../../../components/report/report-style')
const css = style.get()
const { getReportInsertTarget } = require('../../../../../components/report/report-target')

export function start(detail) {

    const phpFile = 'server/php/sql/report.php'
    detail.inf = { entity: 'customer', report: 'customer-profit-period', id: detail.dbid, period: detail.period }

    reportDB.select(detail, phpFile, (data) => {

        insert(detail, data)

    })

}/**/

function insert(detail, data) {

    // report.show(detail, () => {
    //   console.log(detail)

    // })
    const pageTarget = getReportInsertTarget(detail, 'customer-page-right')
    if (!pageTarget) return
    const body = generate(data)

    pageTarget.insertAdjacentHTML("beforeend", body)

}/*insert*/

function generate(data) {

    var body = ''

    body += generateHeader()
    body += generateTop(data[0])
    body += generateTable(data)
    body += `</div> <!-- dataCont -->`
    body += `<div class="report-page">`

    return body
}

function generateHeader() {

    var header = ''
    header += `<div class="report-page" id="miDiv5" ${css.table}>`
    header += `
                    <div class="report-appbar report-appbar-black" >

                            <div  data-detail='{"click": [ 
                                                        {"dest":"ripple" }, 
                                                        {"dest":"report", "act":"remove"} ] }' >
                                <svg><use xlink:href="../css/svg.svg#close"></use></svg>
                            </div>

                            <h1>All Customers Statement: Accounts Profits For A Customer And Period</h1>

                        <div class="fr" data-detail='{"click": [ 
                                                    {"dest":"ripple" }, 
                                                    {"dest":"report", "act":"print" }  ] }' >
                                <svg><use xlink:href="../css/svg.svg#print"></use></svg>
                                <label>Print</label>
                        </div>
                    </div> <!-- appbar -->
            `

    header += `
                    <div class="dataCont">
                        <h1  ${css.f32}></h1>
                        <p   ${css.f14} >
                                 </p>
            `
    return header


}

function generateTop(data) {
    var table = `<br><br><h1 style="text-align: center;">${data.company_name}</h1>
      <h2 style="text-align: center;">Accounts Profits Per Period As Of ${data.current_dateTime}</h2>
      <h2 style="text-align: center;"></h2>
      `;


    return table

}/**/

function generateTable(data) {

    var totals = {
        total_earnings: 0
    };
    var nextFormat = 0;

    var table = `
    <h2 ${css.f15}>Invoice Breakdown for Customer ${data[0].customer_name} - ${data[0].period}: This is a financial document that provides information about money 
                                earned to a company by its customers or clients for goods or services provided on credit.</h2>
    <table ${css.table} class="dt-alterColor">
     <tr >
       <th ${css.th}>Invoice Code</th>
       <th ${css.th}>Date</th>
       <th ${css.th}>Item</th>
       <th ${css.th}>QTY</th>
       <th ${css.th}>Unit Price</th>
       <th ${css.th}>Total Amount</th>
       <th ${css.th}>Profits</th>
     </tr> 
       `

    for (let i = 0; i < data.length; i++) {

        totals.total_earnings += parseFloat(data[i].earnings);

        let detailHtml = `data-detail='{"click": [ {"dest":"ripple" },  
        {"dest":"report",  "act":"jump", 
          "actJump":"goToSales", "dtId":"sale-dt", "toSearch":"${data[i].code}"  } ] }'`

        table += `
            <tr ${rowStyle(i)}>
              <td class='tdClick' ${css.td} ${detailHtml}>${data[i].code}</td>
              <td ${css.td}>${data[i].sale_date}</td>
              <td ${css.td}>${data[i].item_name}</td>
              <td ${css.td}>${data[i].qty}</td>
              <td ${css.td}>${cashVal(data[i].price)}</td>
              <td ${css.td}>${cashVal(data[i].amount)}</td>
              <td ${css.td}>${cashVal(parseFloat(data[i].earnings))}</td>
            </tr> 
        `
        nextFormat = i + 1;

    }

    //PRINITNG EACH COLUMM TOTAL
    table += `
        <tr ${rowStyle(nextFormat)}>
          <td style="text-align: right;" colspan="6"><h2>Total</h2></td>
          <td ${css.td} ><h3>${cashVal(totals.total_earnings)}</h3></td>
        </tr> 
        `

    table += `</table>`

    return table

}

function cashVal(value) {
    return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

function rowStyle(i) {

    if (i % 2 === 0) { return '' }
    return css.trGray

}
